var _path, _circle, _circle2, _circle3, _circle4, _path2, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62364 18.0654C8.04802 18.9219 7.95271 19.9504 7.60073 20.8873C7.00312 22.4794 5.43758 23.3761 3.67772 23.1711C2.16717 22.9954 0.773951 21.6706 0.572301 20.1444C0.476975 19.4087 0.546124 18.7249 0.902274 17.9887C1.45518 16.8034 2.36881 16.1586 3.58238 15.9134C4.72996 15.6828 5.74336 15.2328 6.59763 14.4459C6.63967 14.4134 6.68046 14.3677 6.72061 14.3287C7.54921 13.5235 8.08451 12.561 8.31549 11.4227C8.38881 11.0567 8.48594 10.694 8.64196 10.3504C9.20515 9.11033 10.1122 8.37039 11.4357 8.12152C12.5063 7.92388 13.4266 7.42255 14.2772 6.76742C15.2048 5.9842 15.7179 4.94087 16.1065 3.82459C16.2642 3.38174 16.2752 2.90595 16.4732 2.46676C17.0818 1.11258 18.1524 0.384248 19.5932 0.278111C20.9755 0.175634 22.0864 0.768536 22.8856 1.90677C23.1056 2.22519 23.262 2.57219 23.3402 2.9645C23.5053 3.75526 23.5458 4.50539 23.2341 5.25568C22.8968 6.13772 22.3209 6.80009 21.4703 7.22464C21.419 7.25026 21.3699 7.27228 21.3127 7.29119C21.0247 7.40803 20.7447 7.50665 20.444 7.56886C18.4348 7.97512 16.972 9.08042 16.0957 10.9397C16.0774 10.9799 16.0556 10.9831 16.034 11.0584C16.034 11.0584 15.6996 12.2792 15.5016 12.8867C15.2669 13.615 14.8586 14.1677 14.1964 14.6618C13.7685 15.0096 13.2836 15.2436 12.7593 15.3351C10.9738 15.6462 9.61723 16.5758 8.62364 18.0654Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8934,
    cy: 19.6267,
    r: 3.57333,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.10678,
    cy: 3.84006,
    r: 3.57333,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9999,
    cy: 19.7936,
    r: 2.82,
    stroke: "black",
    strokeWidth: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.65323,
    cy: 11.8711,
    r: 2.74825,
    stroke: "black",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7188 11.7994C22.7188 13.3569 21.4563 14.6194 19.8988 14.6194C18.3414 14.6194 17.0788 13.3569 17.0788 11.7994C17.0788 10.242 18.3414 8.97944 19.8988 8.97944C21.4563 8.97944 22.7188 10.242 22.7188 11.7994Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9999,
    cy: 3.80799,
    r: 2.82,
    stroke: "black",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.4f54364d8b462b644d94aab42e73bc70.svg";
export { ForwardRef as ReactComponent };